import React, { useState, FC } from "react";
import { IntlProvider } from "react-intl";

import en from "../Localization/en.json";
import ja from "../Localization/ja.json";

import { Language, resolveLanguage } from "../utils/language";

const languages = { en, ja };

interface Props {
  children: React.ReactNode;
}

interface ContextProps {
  locale: string;
  selectLanguage: (language: Language) => void;
}

export const Context = React.createContext<ContextProps | null>(null);

const LocalizationWrapper: FC<Props> = ({ children }) => {
  const [locale, setLocale] = useState<Language>(() => resolveLanguage());

  const selectLanguage = (language: Language): void => {
    setLocale(language);
    localStorage.setItem("locale", language);
  };

  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider key={locale} locale={locale} messages={languages[locale]}>
        {children}
      </IntlProvider>
    </Context.Provider>
  );
};
export default LocalizationWrapper;
